// extracted by mini-css-extract-plugin
export default {"container":"hE-z","dimension":"iE-z","dimensionLabels":"jE-z"};